import { CheckCircle2, Eye, Target, Compass } from "lucide-react";
import { PageHero, SectionHead } from "../components/site/PageHero";
import { Reveal } from "../components/site/Reveal";
import { ObjectivesGrid } from "../components/site/Sections";
import { MISSION } from "../data/content";

const BLOCKS = [
  { icon: Eye, title: "Our Vision", text: "A workplace in the IT and digital services sector where every employee is treated with fairness, dignity and security, and has a collective voice." },
  { icon: Target, title: "Our Mission", text: "To organise IT-sector employees, create awareness of their rights, support them in workplace issues, and promote their welfare and professional growth." },
  { icon: Compass, title: "Our Approach", text: "Constructive, lawful and member-driven. We believe in dialogue, awareness and organised representation to resolve workplace concerns." },
];

export default function About() {
  return (
    <>
      <PageHero eyebrow="About Us" title="About the Federation" subtitle="An organised platform working for the collective interests of employees in the IT and digital services sector." testId="about-hero" />
      <section className="py-16 md:py-24">
        <div className="container-x grid gap-12 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <SectionHead eyebrow="Who we are" title="Standing strong for IT employees" />
            <div className="prose-itef mt-6">
              <p>IT Employees Federation is dedicated to protecting the rights, interests, professional dignity and welfare of employees working in the Information Technology sector — including IT professionals, IT service employees, technology-sector workers and digital service industry employees.</p>
              <p>The federation is affiliated to STU (Swatantra Thozhilali Union), a registered trade union associated with the Indian Union Muslim League (IUML). Based in Kozhikode, the federation works to build a strong organisational presence across Kerala and eventually throughout India.</p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <img src="/images/lake-palms.jpg" alt="Kerala landscape" className="h-full max-h-[420px] w-full rounded-2xl object-cover" />
          </Reveal>
        </div>
      </section>
      <section className="bg-slate-100/70 py-16 md:py-24">
        <div className="container-x grid gap-6 md:grid-cols-3">
          {BLOCKS.map(({ icon: Icon, title, text }, i) => (
            <Reveal key={title} delay={i * 0.08}>
              <div className="h-full rounded-xl bg-white p-8 shadow-sm" data-testid={`about-block-${i}`}>
                <Icon className="h-8 w-8 text-royal" />
                <h3 className="mt-5 font-display text-xl font-bold text-navy">{title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="container-x">
          <SectionHead eyebrow="Mission commitments" title="Our mission is to ensure" />
          <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {MISSION.map((m) => (
              <li key={m} className="flex items-start gap-3 rounded-lg border border-slate-200 bg-white p-4 text-sm font-semibold text-navy"><CheckCircle2 className="h-5 w-5 shrink-0 text-leaf" />{m}</li>
            ))}
          </ul>
        </div>
      </section>
      <section className="pb-20">
        <div className="container-x"><SectionHead eyebrow="Our Objectives" title="Six areas of work" /><ObjectivesGrid /></div>
      </section>
    </>
  );
}
